export const pushnami = `<script type="text/javascript">
(function(document, window){
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://api.pushnami.com/scripts/v1/pushnami-adv/5d4046fde93e9d16c92ec63a";
    script.onload = function() {
        Pushnami
            .update()
            .prompt()
    };
    document.getElementsByTagName("head")[0].appendChild(script);
})(document, window);
</script>`;

export const taboola = '<script type=\'text/javascript\'> window._tfa = window._tfa || []; window._tfa.push({notify: \'event\', name: \'page_view\', id: 1181908}); !function (t, f, a, x) { if (!document.getElementById(x)) { t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f); } }(document.createElement(\'script\'), document.getElementsByTagName(\'script\')[0], \'//cdn.taboola.com/libtrc/unip/1181908/tfa.js\', \'tb_tfa_script\'); </script> <noscript> <img src=\'//trc.taboola.com/1181908/log/3/unip?en=page_view\' width=\'0\' height=\'0\' style=\'display:none\'/> </noscript>';

export const outbrain = `<script data-obct type="text/javascript">
  /** DO NOT MODIFY THIS CODE**/
  !function(_window, _document) {
    var OB_ADV_ID='006ef8d23656dd8783d80be35b46b9e5b8';
    if (_window.obApi) {var toArray = function(object) {return Object.prototype.toString.call(object) === '[object Array]' ? object : [object];};_window.obApi.marketerId = toArray(_window.obApi.marketerId).concat(toArray(OB_ADV_ID));return;}
    var api = _window.obApi = function() {api.dispatch ? api.dispatch.apply(api, arguments) : api.queue.push(arguments);};api.version = '1.1';api.loaded = true;api.marketerId = OB_ADV_ID;api.queue = [];var tag = _document.createElement('script');tag.async = true;tag.src = '//amplify.outbrain.com/cp/obtp.js';tag.type = 'text/javascript';var script = _document.getElementsByTagName('script')[0];script.parentNode.insertBefore(tag, script);}(window, document);
obApi('track', 'PAGE_VIEW');
</script>`;

export const visualOptimizerPixel = '';

export const globalSiteTagForm = `<!-- Global site tag (gtag.js) - Google Analytics-->
    <script async src="https://www.googletagmanager.com/gtag/js?id=UA-59380419-1"></script>
    <script async data-id="101453242" src="//static.getclicky.com/js"></script>
    <script>
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-59380419-1', {'page_path': '${window.location.pathname}${window.location.search}'});
    </script>`;

export const presellClickConversion = `<script>gtag('event', 'conversion', {
          'send_to': 'AW-776761050/APX-CIaW7pUBENrdsfIC'
      });</script>`;

export const tyConversionTag = `<script>
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('event','submit',{'event_category':'form','event_label':'get a quote'});
        gtag('event', 'conversion', {'send_to': 'AW-776761050/APX-CIaW7pUBENrdsfIC'});
</script>`;

export const fbPixelFor528 = `<!-- Facebook Pixel Code -->
      <script>
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '336061714000071');
      fbq('track', 'PageView');
      </script>
      <noscript><img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=336061714000071&ev=PageView&noscript=1"
      /></noscript>
      <!-- End Facebook Pixel Code -->`;

export const snapAndFBPixelsSpecificAff = `<script type='text/javascript'>
        (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
        {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
        a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
        r.src=n;var u=t.getElementsByTagName(s)[0];
        u.parentNode.insertBefore(r,u);})(window,document,
        'https://sc-static.net/scevent.min.js');

        snaptr('init', '32e594dc-24fa-4526-8719-de6daf82dd2c', {
        'user_email': '__INSERT_USER_EMAIL__'
        });

        snaptr('track', 'PAGE_VIEW');

      </script>
      <!-- End Snap Pixel Code -->

      <!-- Facebook Pixel Code -->
      <script>
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');

            setTimeout(function(){
              fbq('init', '1630006543970731');
              fbq('track', 'PageView');
          }, 3000);


      </script>
      <noscript><img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=1630006543970731&ev=PageView&noscript=1"
      /></noscript>
      <!-- End Facebook Pixel Code -->`;

export const snapSpecificPixel1850 = '<!-- Snap Pixel Code --><script type=\'text/javascript\'> (function(e,t,n)\\{if(e.snaptr)return;var a=e.snaptr=function() \\{a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)\\}; a.queue=[];var s=\'script\';r=t.createElement(s);r.async=!0; r.src=n;var u=t.getElementsByTagName(s)[0]; u.parentNode.insertBefore(r,u);\\})(window,document, \'https://sc-static.net/scevent.min.js\'); snaptr(\'init\', \'32e594dc-24fa-4526-8719-de6daf82dd2c\', \\{ \'user_email\': \'__INSERT_USER_EMAIL__\' \\}); snaptr(\'track\', \'ADD_CART\'); </script> <!-- End Snap Pixel Code -->';
